import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Container from '../../../elements/Container'
import P from '../../../elements/Typo/P'
import { useExperimentSelector } from '../../../store/selectors/experimentSelector'
import RCTUploadData from './_components/uploadData/RCT/uploadData'
import MTEUploadData from './_components/uploadData/MTE/uploadData'
import MultiKpiUploadData from './_components/uploadData/RCT/multiKpiUploadData'
import { Link } from 'react-router-dom'
import Button from '../../../elements/button'
import { URLS } from '../../../_config'
import { EXPERIMENT_TYPES } from '../../../_common/constant'

interface Props {
    next: () => void
    popup?: boolean
}

const Data: React.FC<Props> = ({ next, popup = false }) => {
    const { t } = useTranslation()
    const experiment = useExperimentSelector()
    const [conversionFlow, setConversionFlow] = useState<boolean>(false)

    useEffect(() => {
        if (experiment?.experiment_metadatas?.metrices != null) {
            let flow: boolean = false
            experiment.experiment_metadatas?.metrices.map((kpi: any) => {
                if (kpi.literral_value == 'Incremental Conversion') {
                    flow = true
                }
            })
            setConversionFlow(flow)
        }
    }, [experiment])

    return (
        <Container size="md">
            <div className="shadow-1 rounded-[0.833rem] p-5">
                {!popup && (
                    <>
                        <div className="flex items-center justify-between">
                            <div className="relative flex items-center gap-2">
                                <div className="absolute -left-5 top-0 h-full w-2 bg-primary rounded-e-md"></div>
                                <P className="!mb-0 font-semibold">{experiment?.experiment_name}</P>
                            </div>
                            {!experiment?.is_measurement_flow && (
                                <Link to={URLS.CREATE_EXPERIMENT(experiment?.experiment_literal) + '?step=3'} className="hidden">
                                    <Button theme="secondary" size="xxs" styleType="outline">
                                        {t('Design')}
                                    </Button>
                                </Link>
                            )}
                        </div>
                        {experiment?.experiment_type?.title == 'Post-Treatment Comparison' && (
                            <div className="flex justify-center w-full">
                                <div className=" text-[0.8rem] text-yellow-700 bg-yellow-200 rounded-md px-4 py-2 leading-none my-3 font-medium">
                                    {t('Ensure that measurement data is aggregated at the Granularity Column level and for the correct measurement time period.')}
                                </div>
                            </div>
                        )}
                    </>
                )}

                {conversionFlow && <MultiKpiUploadData popup={popup} next={next} />}
                {(experiment?.experiment_type?.title == EXPERIMENT_TYPES.RCT.title ||
                    experiment?.experiment_type?.title == EXPERIMENT_TYPES.PTC.title ||
                    experiment?.experiment_type?.title == EXPERIMENT_TYPES.OBS.title ||
                    experiment?.experiment_type?.title == EXPERIMENT_TYPES.DML.title) &&
                    !conversionFlow && <RCTUploadData popup={popup} next={next} />}
                {experiment?.experiment_type?.title == EXPERIMENT_TYPES.MTE.title && <MTEUploadData next={next} />}
            </div>
        </Container>
    )
}

export default Data
